import React from 'react';
import { connect } from 'react-redux';

import { changeFormField } from 'apps/auth/actions/formAction';
import { AMOUNT_FROM, AMOUNT_TO, AMOUNT_TO_CCY } from 'apps/auth/constants/fieldsName';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { getCurrencyIcon, onIconRenderError } from 'apps/auth/helpers/utils';
import { CurrencyService } from 'apps/auth/services/currencyService';
import { GaSendingAmountValidationService } from 'apps/auth/services/GaSendingAmountValidationService';

import CalculatorCurrenciesPopup from './popups/CalculatorCurrenciesPopup';
import GaCalculatorScreen from '../calculator/GACalculatorScreen';

export const GaSendCalculatorScreen = (props) => {
    const validationService = new GaSendingAmountValidationService({
        minValidError: props.minValidError,
        viewDetails: props.viewDetails,
        limitReached: props.limitReached,
    });
    const apiFetchDataUrl = `/auth/ga/pocket/${props.pocket?.id}/send.calculate`;
    const saveMoneyCodeFetchUrl = `/auth/ga/pocket/${props.pocket?.id}/send.calculate?isFrom=true`;
    const currencyFrom = props.pocket.pocketCurrency;
    const fetchCurrencyUrl = `${AUTH_GA_POCKET}${props.pocket?.id}`;

    const getValidationError = (value, min, max, multiple, isFrom, currencyCode) => {
        return validationService.getValidationError(value, min, max, multiple, isFrom, props.pocket?.balance, currencyCode);
    };

    const onSelectCurrencyClick = (e, currencies, amountCcy) => {
        props.popupRef?.current?.open(
            <CalculatorCurrenciesPopup
                title={props.selectDeliverCurrencyTitle}
                formName={props.formName}
                currencies={currencies}
                current={amountCcy}
                fetchCurrencyUrl={fetchCurrencyUrl}
                popupRef={props.popupRef}
                getCurrencyIcon={getCurrencyIcon}
                onIconRenderError={onIconRenderError}
            />,
        );
    };

    const onContinueButtonClick = (e) => {
        props.checkFieldsAndSubmitFormIfHasNoErrors(e, [props.amountFrom, props.amountTo]);
    };
    return (
        <GaCalculatorScreen
            formName={props.formName}
            fetchCommissionUrl={apiFetchDataUrl}
            getValidationError={getValidationError}
            currencyFrom={currencyFrom}
            currencyTo={CurrencyService.getCurrentCurrency(props.currenciesTo, props.amountToCcy)}
            currenciesFrom={[currencyFrom]}
            currenciesTo={props.currenciesTo}
            onSelectCurrencyClick={onSelectCurrencyClick}
            onContinueButtonClick={onContinueButtonClick}
            promoCodeFetchUrl={saveMoneyCodeFetchUrl}
        />
    );
};

const mapStateToProps = (state, ownProps) => ({
    pocket: state.extra.pocket,
    minValidError: state.messages.jsMessages['site.js.ga.validation.min.valid.error'],
    formName: ownProps.formName,
    checkFieldsAndSubmitFormIfHasNoErrors: ownProps.checkFieldsAndSubmitFormIfHasNoErrors,
    currenciesTo: state.extra.toCountry.currencies,
    currencyFrom: state.extra.fromCurrency,
    amountToCcy: state.form[ownProps.formName].fields[AMOUNT_TO_CCY].value,
    amountFrom: state.form[ownProps.formName].fields[AMOUNT_FROM],
    amountTo: state.form[ownProps.formName].fields[AMOUNT_TO],
    viewDetails: state.messages.pageMessages.viewDetails,
    limitReached: state.messages.pageMessages.limitReached,
    selectDeliverCurrencyTitle: state.messages.pageMessages.selectDeliverCurrencyTitle,
});

export default connect(mapStateToProps, { changeFormField })(GaSendCalculatorScreen);
